(() => {
  document.addEventListener('click', event => {
    if (!window.matchMedia('(max-width: 768px)').matches) return;
    if (event.target.closest('[data-fuja-support] > .main-nav__row > a.main-nav__item--primary')) {
      event.stopPropagation();
      return;
    }
    const trigger = event.target.closest('[data-fuja-support] > .main-nav__row > button.js-toggle');
    if (!trigger) return;
    const parent = trigger.closest('[data-fuja-support]');
    const expanded = parent.classList.toggle('fm-expanded');
    parent.querySelectorAll(':scope > .main-nav__row > [aria-expanded]').forEach(element => element.setAttribute('aria-expanded', String(expanded)));
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  const setup = root => root.querySelectorAll('[data-fuja-order-menu]').forEach(menu => {
    if (menu.dataset.ready === 'true') return;
    menu.dataset.ready = 'true';
    const search = menu.querySelector('[data-fm-search]');
    const columns = [...menu.querySelectorAll('[data-fm-column]')];
    const empty = menu.querySelector('[data-fm-empty]');
    search?.addEventListener('input', () => {
      const value = search.value.trim().toLowerCase();
      let total = 0;
      columns.forEach(column => {
        let visible = 0;
        column.querySelectorAll('[data-fm-item]').forEach(item => {
          const hit = !value || item.textContent.toLowerCase().includes(value);
          item.hidden = !hit;
          if (hit) visible++;
        });
        column.hidden = visible === 0;
        total += visible;
      });
      empty.hidden = total !== 0;
    });
    const accordions = [...menu.querySelectorAll('.fm-accordion')];
    accordions.forEach(current => current.addEventListener('toggle', () => {
      if (current.open) accordions.forEach(other => { if (other !== current) other.open = false; });
    }));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

